import View from './ModulesView'

export default {
    View
}